export default (file, name) => {
  // try {
  //   blob = new Blob([result], { type: 'application/pdf' });
  // } catch (e) {
  //   window.BlobBuilder = window.BlobBuilder ||
  //     window.WebKitBlobBuilder ||
  //     window.MozBlobBuilder ||
  //     window.MSBlobBuilder
  //   if (window.BlobBuilder) {
  //     var bb = new BlobBuilder()
  //     bb.append(result)
  //     blob = bb.getBlob("application/pdf")
  //   }
  // }
  
  const blob = new Blob([file])

  if (window.navigator.msSaveBlob) {
    return window.navigator.msSaveBlob(blob, name)
  }
  // link.href = window.URL.createObjectURL(blob)
  // link.setAttribute('download', name)
  // return link.click()

  
  const fileLink = document.getElementById('downloadFile')
  fileLink.href = window.URL.createObjectURL(blob)
  fileLink.setAttribute('download', name)
  return fileLink.click()
}
